<!-- Institute of Design and Innovation (email idi@unm.edu). -->

<!-- Home page -->
<template>
  <div class="home">s
    {{ forecaste }}

    <button @click="getStuff">Get It</button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Home',

  data () {
    return {
      forecaste: []
    }
  },

  methods: {
    getStuff () {
      this.$axios.get('weatherforecast').then(res => {
        this.forecaste = res.data
      })
    }
  }
})
</script>
